<div class="label-select" [style.width]="width() + 'px'">
    <div class="tw-flex tw-w-full tw-gap-x-1">
        <p-button class="label-select-icon"
            (onClick)="labelsMultiSelect.show(true)"
            (keydown.enter)="labelsMultiSelect.show(true)"
            [ariaLabel]="actionButtonAriaLabel()"
            [rounded]="true"
            [variant]="'text'"
            [severity]="'primary'"
            #iconButton
        >
            @if (buttonIcon() === 'edit') {
                <!-- TODO: Replace inline SVG with reusable icons -->
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="material-symbol-svg" fill="currentColor" viewBox="0 -960 960 960"><path d="M200-200h57l391-391-57-57-391 391v57Zm-40 80q-17 0-28.5-11.5T120-160v-97q0-16 6-30.5t17-25.5l505-504q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L313-143q-11 11-25.5 17t-30.5 6h-97Zm600-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z"/></svg>
            } @else {
                <!-- TODO: Replace inline SVG with reusable icons -->
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="material-symbol-svg" fill="currentColor" viewBox="0 -960 960 960"><path d="M451.5-131.5Q440-143 440-160v-280H160q-17 0-28.5-11.5T120-480q0-17 11.5-28.5T160-520h280v-280q0-17 11.5-28.5T480-840q17 0 28.5 11.5T520-800v280h280q17 0 28.5 11.5T840-480q0 17-11.5 28.5T800-440H520v280q0 17-11.5 28.5T480-120q-17 0-28.5-11.5Z"/></svg>
            }
        </p-button>
        <div class="selected-labels-container tw-flex tw-gap-x-1 tw-gap-y-2 tw-pointer-events-none"
            [ngClass]="{'tw-flex-wrap': !labelsCollapsed()}"
            [style.width]="selectedLabelsContainerWidth() + 'px'"
        >
            @for (label of visibleSelectedLabels(); track label.id) {
                <p-chip [label]="label.name" styleClass="tw-cursor-default" [attr.title]="label.name" [ngStyle]="{ color: label.color | adaptiveColor, 'background-color': label.color }" />
            }
            @if ((selected() || []).length > 2) {
                <p-button class="more-selected-labels-indicator tw-cursor-pointer tw-pointer-events-auto"
                    [ngClass]="{'p-hidden-accessible': !labelsCollapsed()}"
                    [label]="`+${(selected() || []).length - 2}`"
                    [ariaLabel]="'label.expandAllBtn' | transloco"
                    (onClick)="labelsCollapsed.set(false)"
                    size="small"
                    rounded
                    outlined
                />
            }
        </div>
    </div>
    <div class="label-select-multi-select-container">
        <p-multi-select
            [tabindex]="-1"
            [attr.aria-hidden]="!overlayVisible()"
            #labelsMultiSelect
            (onPanelHide)="focusToggleButton(iconButton)"
            (onFilter)="onMultiSelectFilter($event)"
            (onLazyLoad)="onLazyLoad($event)"
            [(ngModel)]="selected"
            (ngModelChange)="throttledRequestUpdateLabels($event)"
            [autofocusFilter]="true"
            [autofocus]="false"
            [filter]="true"
            [filterValue]="''"
            [lazy]="true"
            [options]="labelMultiSelectItems()"
            [panelStyle]="{width: `${width()}px`}"
            [resetFilterOnHide]="true"
            [showToggleAll]="false"
            [virtualScrollItemSize]="50"
            [virtualScrollOptions]="{ showLoader: true, loading: loading() }"
            [virtualScroll]="enableVirtualScroll"
            [overlayOptions]="overlayOptions"
            [emptyFilterMessage]="emptySearchMessage()"
            [emptyMessage]="emptyMessage()"
            dataKey="id"
            appendTo="body"
            [filterMatchMode]="$any('notFilter')"
            fluid
            optionLabel="name"
        >
            <ng-template #footer>
                <div class="tw-p-2 tw-flex tw-justify-between">
                    <p-button class="label-select-add" *ngIf="canManageLabels" icon="pi pi-plus" [label]="'label.select.addLabelButton' | transloco" text size="small" (onClick)="onAddLabel()" />
                    <p-button icon="pi pi-trash" [label]="'label.select.clearLabelsButton' | transloco" text size="small" (onClick)="onClearLabels()" />
                </div>
            </ng-template>
        </p-multi-select>
    </div>
</div>
